import Phaser from "phaser";
import "@fontsource/bangers";
import "@fontsource/cherry-bomb-one";
import "@fontsource/great-vibes";
import "./styles.css";
import { GameScene } from "./game/GameScene";
import { moormennersTheme } from "./theme/moormennersTheme";
import { initOverlay } from "./ui/overlay";

const game = new Phaser.Game({
  type: Phaser.AUTO,
  parent: "game-root",
  width: moormennersTheme.round.viewportWidth,
  height: moormennersTheme.round.viewportHeight,
  backgroundColor: moormennersTheme.ui.colors.page,
  scene: [GameScene],
  physics: {
    default: "arcade",
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false
    }
  },
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },
  render: {
    antialias: true,
    pixelArt: false
  }
});

const windmillDebug = new URLSearchParams(window.location.search).has("windmillDebug");

const startRound = () => {
  game.scene.stop("GameScene");
  game.scene.start("GameScene", {
    theme: moormennersTheme,
    active: true,
    windmillDebug
  });
};

initOverlay({
  root: document.querySelector("#overlay-root") as HTMLElement,
  theme: moormennersTheme,
  startRound,
  hidden: windmillDebug
});

if (windmillDebug) {
  startRound();
}
